import { render, staticRenderFns } from "./ShopCheckout.vue?vue&type=template&id=5f2845d0&scoped=true&"
import script from "./ShopCheckout.vue?vue&type=script&lang=js&"
export * from "./ShopCheckout.vue?vue&type=script&lang=js&"
import style0 from "./ShopCheckout.vue?vue&type=style&index=0&id=5f2845d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2845d0",
  null
  
)

export default component.exports